<template>
  <div class="article-tile-item">
    <v-img class="article-tile-img" :src="tile.imageUrl" />
    <div class="article-tile-content">
      <h1 v-html="tile.title" class="title-tile"></h1>
      <p class="description">
        {{ tile.description }}
      </p>
      <FunkButton
        :id="tile.id"
        :button-text="tile.buttonText"
        @buttonClicked="handleClick"
      ></FunkButton>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ArticleTile',
    props: {
      tile: {
        required: true,
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {};
    },
    created() {},
    methods: {
      handleClick() {
        this.$emit('buttonClicked', this.tile.id);
      },
    },
  };
</script>

<style scoped lang="scss">
  .article-tile-item {
    box-shadow: 0px 1px 3px 0px #00000024;
    border-radius: 0px 0px 2px 2px;
    flex: 1;
    overflow: hidden;
    background-color: #ffffff;

    .article-tile-img {
      height: 196px;
    }

    .color-margin {
      background-color: #ed0080;
      height: 8px;
    }

    .article-tile-content {
      padding: 24px;
      padding-bottom: 31px;

      .title-tile {
        font-size: 12px;
        font-weight: 600;
        line-height: 20px;
        letter-spacing: 1.25px;
        text-align: left;
        margin-bottom: 14px;
        color: #747474;
      }
      .description {
        font-family: Montserrat;
        font-size: 16px;
        font-weight: 500;
        line-height: 20px;
        letter-spacing: 0.15000000596046448px;
        text-align: left;
        color: #1e1e1e;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
      }
    }
  }
</style>
